module.exports = __webpack_public_path__ + "img/23_28.1cded7b2.png";